import { useId } from "react";
import type { ReactNode } from "react";
import { useI18n } from "../i18n";

export function Disclosure({
  open,
  onToggle,
  title,
  children,
}: {
  open: boolean;
  onToggle: () => void;
  title: string;
  children: ReactNode;
}) {
  const { m } = useI18n();
  const panelId = useId();
  return (
    <div className="field-group">
      <button type="button" className="disclosure-header" aria-expanded={open} aria-controls={panelId} onClick={onToggle}>
        <span className="disclosure-title">{title}</span>
        <span className="disclosure-toggle">{open ? m.common.hide : m.common.show}</span>
      </button>
      {open && (
        <div id={panelId} className="disclosure-panel">
          {children}
        </div>
      )}
    </div>
  );
}
